import { colors } from "./../../../../styles/variables"
import { Td, Th } from "@chakra-ui/react"
import styled from "@emotion/styled"

export const StyledTd = styled(Td)`
  padding: 10px;
  font-size: var(--chakra-fontSizes-base);
  font-family: var(--chakra-fonts-main);
  line-height: 28px;
  color: var(--chakra-colors-main_text_color);
`

export const StyledTh = styled(Th)`
  padding:6px 10px;
  color: #000000;
  opacity: 0.5;
  line-height: s;
  font-size: 12px;
  letter-spacing: normal;
  font-family: "main", sans-serif;
`
